<template>
  <div class="main-box mh-a solutionpage">
    <div class="h140px ovh lh140 fs30 c-white text-center solution-title"
      :style="`background-image: url(${solutionDetial.showImg});`">
      {{ solutionDetial.title }}
    </div>
    <!-- <div style="font-size: 22px;margin:20px 0;padding-top: 10px; ">{{ solutionDetial.title }}</div> -->
    <!-- <div style="font-size: 18px;margin:10px 0;">{{ solutionDetial.desc }}</div> -->
    <div v-for="(info, idx) in solutionDetial.info" :key="`${idx}_info`" :class="solutionDetial.class">

      <div class="fs14  lh30 c-g-d  pt15 splu-text detailContent ">
        <div style="" class="item-img">
          <img style="width: 100%;" :src="'/static/img/programme/' + solutionDetial.img[idx]" alt="">
        </div>
        <div class="detailP" style="flex:1" :class="solutionDetial.class + idx" v-html="info"></div>
      </div>
    </div>
    <ul class="flex text-center j-c-sa mb50">
      <li class="m-solu-icon" v-for="(img, dx) in solutionDetial.iconData" :key="`${dx}_info`">
        <img width="120" :src="img.img" />
        <p class="fs12 lh40 c-g-d">{{ img.title }}</p>
      </li>
    </ul>
    <div class="h120px"></div>
    <!-- <el-carousel
            type="card"
            :autoplay="false"
            class="slide-box mh-a"
            @change="slideChange"
            arrow="never"
            indicator-position="none"
        >
            <el-carousel-item

                class="text-center"
                v-for="(item, index) in solutionDetial.infoData"
                :key="`${index}_car`"
            >
                <div class="p-r">
                    <el-image :src="item.img" fit="contain" class="h-total"></el-image>
                    <transition name="el-fade-in">
                        <div class="cover" v-show="slideIndex !== index"></div>
                    </transition>
                </div>
            </el-carousel-item>
        </el-carousel> -->
    <!-- 销售热线 -->
    <!-- <sales-hotline></sales-hotline> -->
  </div>
</template>

<script>
// import SalesHotline from "@/components/SalesHotline";
import solutionList from "@/assets/solution/solutionList";
import solutionListEn from "@/assets/solution/solutionList-en";
// import solutionListEn from "@/assets/solution/solutionList";
export default {
  name: "SolutionDetails",
  data() {
    return {
      slideIndex: 0,
    };
  },
  components: {
    // SalesHotline,
  },
  computed: {
    solutionDetial() {
      let list =
        this.$store.state.language === "zh" ? solutionList : solutionListEn;
      let detialArr = list.filter((item) => {
        return item.index == this.$route.params.index;
      });
      return detialArr[0];
    },
  },
  methods: {
    slideChange(index) {
      this.slideIndex = index;
    },
  },
};
</script>



<style lang="less">
.solutionpage .detailP p {
  margin-bottom: 0.6em;
  line-height: 1.5em;
}

.solutionpage {
  .detailContent {
    padding: 20px 30px;

    p {
      font-size: 17px;
    }

    .tit {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 0.8em;
      margin-top: 0.3em;
    }
  }
}



@media (min-width: 768px) {
  .solutionpage {
    .detailContent {
      display: flex;
      padding: 50px 100px;
      align-content: center;
      justify-content: center;
      align-items: center;
    }

    .item-img {
      width: 320px;
      margin-right: 15px;
    }

    .detailP {
      padding-left: 50px;
      padding-right: 130px;

      p {
        margin-bottom: 1em;
        line-height: 2em;

      }

      .tit {
        font-size: 19px;
        font-weight: 600;
        margin-bottom: 1.2em;
      }
    }

    .solutionpage .item-a0 {
      margin-top: 30px;
    }

    .solutionpage .item-a2 {
      margin-top: 16px;
    }

    .solutionpage .item-a3 {
      margin-top: 30px;
    }

    .solutionpage .item-b0 {
      margin-top: 20px;
    }

    .solutionpage .item-b1 {
      margin-top: 20px;
    }

    .solutionpage .item-b2 {
      margin-top: 20px;
    }

    .solutionpage .item-b3 {
      margin-top: 20px;
    }


    .solutionpage .item-c0 {
      margin-top: 20px;
    }

    .solutionpage .item-c1 {
      margin-top: 20px;
    }

    .solutionpage .item-c2 {
      margin-top: 20px;
    }

    .solutionpage .item-c3 {
      margin-top: 20px;
    }

    .solutionpage .item-d0 {
      margin-top: 20px;
    }

    .solutionpage .item-d1 {
      margin-top: 20px;
    }

    .solutionpage .item-d2 {
      margin-top: 20px;
    }

    .solutionpage .item-d3 {
      margin-top: 20px;
    }

    .solutionpage .item-e0 {
      margin-top: 20px;
    }

    .solutionpage .item-e1 {
      margin-top: 20px;
    }

    .solutionpage .item-e2 {
      margin-top: 20px;
    }

    .solutionpage .item-e3 {
      margin-top: 20px;
    }

    .solutionpage .item-f0 {
      margin-top: 20px;
    }

    .solutionpage .item-f1 {
      margin-top: 20px;
    }

    .solutionpage .item-f2 {
      margin-top: 20px;
    }

    .solutionpage .item-f3 {
      margin-top: 20px;
    }
  }
}
</style>